import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { history } from "../store";
import Box from "../components/Box";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import LoadingProgress from "../components/LoadingProgress";

import { fetchMatrixs } from "../actions/matrixs";
import { getLockersName } from "../utils/machines";
import ErrorMessage from "../components/ErrorMessage";
import {
  postBooking,
  postPrebooking,
  postCancelPrebooking,
  fetchCustomer,
} from "../actions/qrs";
import { postPDAsale, fetchPDACustomer } from "../actions/pdas";
import StepBar from "../components/StepBar";
import { fetchSaleTicket } from "../actions/sales";
import { postCounterInvoicePDASale } from "../actions/pdas";
import ReactCountryFlag from "react-country-flag";
import PHONE_PREFIXES from "../utils/phonePrefixes";
import "../styles/LockerSaleView.css";

class LockerSaleView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      bookingInProgress: false,
      phoneValue: "",
      zoneSelected: 0,
      lockerSelected: "",
      lockerResult: 0,
      lockerType: "",
      lockerPass: "000000",
      machineResult: "XXXX",
      machineFirstIndex: 0,
      lockerAssigned: false,
      prebooking: false,
      lockerPin: "",
      lockerMatricula: 0,
      minutes: 5,
      seconds: 0,
      isTimeUp: false,
      booked: false,
      lockerPrice: 0,
      stepBarStep: 1,
      invoice: "00000000",
      time: "",
      customer: "",
      cif: "",
      address: "",
      phoneDuplicate: false,
      choiceMade: 0,
      ticketInvoice: "",
      saleData: null,
      counterInvoiceData: null,
      fetchingSale: false,
      saleNotFound: false,
      confirmationStep: 0,
      devolutionMethod: null,
      groupLockers: [],
      groupTotalPrice: 0,
      groupBookingComplete: false,
      groupBookingInProgress: false,
      groupBookingCurrent: 0,
      groupPhoneValue: "",
      groupConfirmed: false,
      phonePrefix: '+34',
      prefixOpen: false,
      groupPhonePrefix: '+34',
      groupPrefixOpen: false,
    };

    this.prefixRef = React.createRef();
    this.groupPrefixRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);

    this.props
      .fetchCustomer(this.props.id)
      .then((answer) => {
        if (answer.response.Customer) {
          this.props.fetchPDACustomer(answer.response.Customer);

          this.props
            .fetchCustomer(answer.response.Customer)
            .then((answer) => {
              this.setState({
                customer: answer.response.Social_name,
                cif: answer.response.Invoice_taxid,
                address: answer.response.Invoice_address,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          this.setState({
            customer: answer.response.Social_name,
            cif: answer.response.Invoice_taxid,
            address: answer.response.Invoice_address,
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
    this.resetProcess();
  }

  handleOutsideClick = (e) => {
    if (this.prefixRef.current && !this.prefixRef.current.contains(e.target)) {
      this.setState({ prefixOpen: false, prefixSearch: '' });
    }
    if (this.groupPrefixRef.current && !this.groupPrefixRef.current.contains(e.target)) {
      this.setState({ groupPrefixOpen: false, groupPrefixSearch: '' });
    }
  };

  fetchSaleTicket = () => {
    const { ticketInvoice } = this.state;

    this.setState({ fetchingSale: true, saleNotFound: false });

    this.props
      .fetchSaleTicket(ticketInvoice)
      .then((answer) => {
        if (answer && answer.response) {
          this.setState({
            saleData: answer.response,
            fetchingSale: false,
            confirmationStep: 1,
          });
        } else {
          this.setState({
            fetchingSale: false,
            saleNotFound: true,
          });
        }
      })
      .catch(() => {
        this.setState({
          fetchingSale: false,
          saleNotFound: true,
        });
      });
  };

  generateCounterInvoice = () => {
    const { ticketInvoice, devolutionMethod } = this.state;

    this.props
      .postCounterInvoicePDASale(ticketInvoice, devolutionMethod)
      .then((answer) => {
        this.setState({
          counterInvoiceData: answer.response,
          confirmationStep: 2,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleRedirect = () => {
    this.resetProcess();
  };

  handleInvoiceInput = (e) => {
    this.setState({ ticketInvoice: e.target.value });
  };

  handleDevolutionMethodInput = (e) => {
    this.setState({ devolutionMethod: e.target.value });
  };

  startCountdown = () => {
    this.countdownInterval = setInterval(() => {
      if (this.state.seconds > 0) {
        this.setState((prevState) => ({ seconds: prevState.seconds - 1 }));
      } else {
        if (this.state.minutes > 0) {
          this.setState((prevState) => ({
            minutes: prevState.minutes - 1,
            seconds: 59,
          }));
        } else {
          clearInterval(this.countdownInterval);
          // Here you can add any logic you want to perform after the countdown reaches 0
          this.setState({ isTimeUp: true });
        }
      }
    }, 1000);
  };

  printLockerTicket(e, printIndex) {
    const content = document.getElementById(`${printIndex}`).innerHTML;
    const printWindow = window.open("", "", "height=600,width=400");
    printWindow.document.write(`
      <html>
        <head>
          <title>TICKET</title>
          <style>
            * { box-sizing: border-box; margin: 0; padding: 0; }
            body {
              font-family: 'Courier New', Courier, monospace;
              font-size: 13px;
              color: #000;
              background: #fff;
              padding: 12px;
              width: 100%;
            }
            .ls-ticket {
              width: 100%;
              max-width: 280px;
              margin: 0 auto;
              text-align: center;
            }
            .ls-ticket-header { margin-bottom: 4px; }
            .ls-ticket-label {
              display: block;
              font-size: 10px;
              text-transform: uppercase;
              letter-spacing: 1px;
              color: #666;
            }
            .ls-ticket-big {
              display: block;
              font-size: 22px;
              font-weight: bold;
            }
            .ls-ticket-hero { margin-bottom: 4px; }
            .ls-ticket-pin {
              display: block;
              font-size: 28px;
              font-weight: bold;
              letter-spacing: 4px;
            }
            .ls-ticket-type {
              font-size: 12px;
              font-weight: bold;
              text-transform: uppercase;
              margin-bottom: 4px;
            }
            .ls-ticket-divider {
              border-top: 1px solid #000;
              margin: 6px 0;
            }
            .ls-ticket-divider-dashed {
              border-top: 1px dashed #000;
              margin: 6px 0;
            }
            .ls-ticket-company {
              font-size: 12px;
              font-weight: bold;
            }
            .ls-ticket-sub {
              font-size: 11px;
              color: #444;
            }
            .ls-ticket-row {
              display: flex;
              justify-content: space-between;
              font-size: 12px;
              padding: 1px 0;
            }
            .ls-ticket-row-bold { font-weight: bold; }
            .ls-ticket-row-sm { font-size: 11px; color: #444; }
            .ls-ticket-total {
              font-weight: bold;
              font-size: 14px;
              margin-top: 4px;
              padding-top: 4px;
              border-top: 2px solid #000;
            }
          </style>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  }

  getLockerPcPicture(type) {
    return `/images/measures/locker_final_${type}.png`;
  }

  renderChoice() {
    const { customer, error } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!customer) {
      return <LoadingProgress />;
    }

    return (
      <>
        <div
          className="ls-choice-card"
          onClick={() => this.setState({ choiceMade: 1 })}
        >
          <div className="ls-choice-icon ls-choice-sell">
            <i className="fas fa-tag"></i>
          </div>
          <h2 className="ls-choice-title">Venta Individual</h2>
          <p className="ls-choice-desc">
            Selecciona una taquilla, asigna un teléfono de respaldo e imprime el
            ticket con el PIN de acceso.
          </p>
          <div className="ls-choice-footer">
            <span className="ls-choice-badge ls-choice-badge-blue">
              <i className="fas fa-cube"></i> 1 taquilla
            </span>
          </div>
        </div>
        <div
          className="ls-choice-card"
          onClick={() => this.setState({ choiceMade: 3 })}
        >
          <div className="ls-choice-icon ls-choice-group">
            <i className="fas fa-users"></i>
          </div>
          <h2 className="ls-choice-title">Venta en Grupo</h2>
          <p className="ls-choice-desc">
            Selecciona múltiples taquillas de distintos tipos, asigna un
            teléfono común e imprime todos los tickets de una vez.
          </p>
          <div className="ls-choice-footer">
            <span className="ls-choice-badge ls-choice-badge-amber">
              <i className="fas fa-cubes"></i> Múltiples taquillas
            </span>
          </div>
        </div>
        <div
          className="ls-choice-card"
          onClick={() => this.setState({ choiceMade: 2 })}
        >
          <div className="ls-choice-icon ls-choice-return">
            <i className="fas fa-undo-alt"></i>
          </div>
          <h2 className="ls-choice-title">Generar Contrafactura</h2>
          <p className="ls-choice-desc">
            Busca una factura existente por su código y genera la contrafactura
            correspondiente para registrar la devolución.
          </p>
          <div className="ls-choice-footer">
            <span className="ls-choice-badge ls-choice-badge-green">
              <i className="fas fa-file-invoice"></i> Devolución
            </span>
          </div>
        </div>
      </>
    );
  }

  renderZones() {
    const { customer, error, category } = this.props;

    const zonesRow = [];

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!customer) {
      return <LoadingProgress />;
    }

    if (customer.Zones) {
      customer.Zones.filter((zone) =>
        category === "BAQUEIRA" ? zone.Zone === 6 : true,
      ).map((zone, index) => {
        zonesRow.push(
          <div
            key={zone.Zone}
            className={
              this.state.zoneSelected === zone.Zone ? "cubeselected" : "cube"
            }
            onClick={(e) => {
              (this.setState({
                zoneSelected: zone.Zone,
                lockerAssigned: false,
                lockerSelected: "",
                phoneValue: "",
                stepBarStep: 2,
              }),
                this.props.fetchMatrixs("", "", customer._id, zone.Zone));
            }}
          >
            <img
              src="/images/Ping.svg"
              alt={"Ping " + zone}
              className="pingImage"
            />
            <h5>{`Zona ${zone.Zone}`}</h5>
            <hr className="bg-vw-light" />
            <h5>{zone.Description}</h5>
          </div>,
        );
      });
    } else {
      this.setState({
        zoneSelected: 0,
        lockerAssigned: false,
        lockerSelected: "",
        phoneValue: "",
        stepBarStep: 2,
      });
      this.props.fetchMatrixs("", "", customer._id, "");
    }

    return zonesRow;
  }

  renderLockers() {
    const { pda, matrixs, error, loading } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!pda || !matrixs || loading) {
      return (
        <div>
          <LoadingProgress />
          <h5>Esperando Zona...</h5>
        </div>
      );
    }

    // Ordered list of locker keys
    const orderedLockerKeys = [
      "LOCKERBNS",
      "LOCKERCNS",
      "LOCKERBWS",
      "LOCKERCWS",
      "LOCKERBNM",
      "LOCKERCNM",
      "LOCKERBWM",
      "LOCKERCWM",
      "LOCKERBNL",
      "LOCKERCNL",
      "LOCKERBWL",
      "LOCKERCWL",
      "LOCKERBNXL",
      "LOCKERCNXL",
      "LOCKERBWXL",
      "LOCKERCWXL",
      "LOCKERBN2XL",
      "LOCKERCN2XL",
      "LOCKERBW2XL",
      "LOCKERCW2XL",
      "LOCKERBN3XL",
      "LOCKERCN3XL",
      "LOCKERBW3XL",
      "LOCKERCW3XL",
    ];

    // Collect available lockers with counts
    const availableLockerCounts = {};

    matrixs.forEach((matrix) => {
      matrix.Locker.forEach((lock) => {
        if (lock.Configured && lock.Status === "BL") {
          const key = `LOCKER${lock.Mode}${lock.Wide}${lock.Type}`;
          availableLockerCounts[key] = (availableLockerCounts[key] || 0) + 1;
        }
      });
    });

    // Build a calendar price lookup for today keyed by type, filtered by selected zone
    const calendarPriceMap = {};
    if (Array.isArray(pda.CalendarPrices)) {
      pda.CalendarPrices.forEach(entry => {
        if (entry.zone === this.state.zoneSelected) {
          calendarPriceMap[entry.type] = { price: entry.price, fromCalendar: entry.fromCalendar };
        }
      });
    }

    // Render in correct order
    const lockersRow = orderedLockerKeys
      .filter((lockerKey) => availableLockerCounts[lockerKey])
      .map((lockerKey) => {
        const lockerName = getLockersName(lockerKey);
        const lockerType = lockerKey.slice(6); // e.g. "BNS"
        const lockerItem = (pda.Items || []).find(
          (item) => item.item === lockerKey,
        );

        // Use calendar price if available for this zone/type, otherwise fall back to contract price
        const calendarEntry = calendarPriceMap[lockerType];
        const hasCalendarPrice = calendarEntry && calendarEntry.fromCalendar;
        const displayPrice = calendarEntry !== undefined
          ? calendarEntry.price
          : (lockerItem ? lockerItem.price : 0);

        const availableCount = availableLockerCounts[lockerKey] || 0;
        const isSelected = this.state.lockerSelected === lockerType;

        return (
          <div
            key={lockerKey}
            className={
              isSelected ? "cubeselected ls-group-cube" : "cube ls-group-cube"
            }
            onClick={() => {
              this.prebookLocker(
                lockerType,
                displayPrice,
              );
            }}
          >
            <h5>{lockerName}</h5>
            <img
              src={this.getLockerPcPicture(lockerType)}
              alt={lockerName}
              className="ls-group-locker-img"
            />
            <div className="cube-price mb-1">
              {displayPrice !== undefined ? displayPrice.toFixed(2) + "€" : "N/A"}
            </div>
            <div className="ls-group-available">
              {availableCount} disponible{availableCount !== 1 ? "s" : ""}
            </div>
            {hasCalendarPrice && <span className="ls-calendar-badge" title="Precio de calendario"><i className="fas fa-calendar-alt"></i> Precio dinámico</span>}
          </div>
        );
      });

    if (lockersRow.length === 0) {
      return (
        <div className="p-5">
          <h5>Lamentamos informarte que no quedan taquillas disponibles</h5>
        </div>
      );
    }

    return lockersRow;
  }

  renderPhone() {
    const { minutes, seconds, phonePrefix, prefixOpen, prefixSearch } = this.state;
    const selectedCountry = PHONE_PREFIXES.find(p => p.dial === phonePrefix) || PHONE_PREFIXES[0];

    return (
      <div className="input-container text-center">
        <p>
          Hemos reservado una taquilla, introduce un teléfono de respaldo y
          asigna la taquilla dentro del tiempo marcado
        </p>
        <div className="ls-phone-row">
          <div className="ls-prefix-picker" ref={this.prefixRef}>
            <button
              type="button"
              className="ls-prefix-trigger"
              onClick={() => this.setState(s => ({ prefixOpen: !s.prefixOpen }))}
            >
              <ReactCountryFlag
                countryCode={selectedCountry.code}
                svg
                style={{ width: '1.4em', height: '1.4em', borderRadius: '3px' }}
              />
              <span>{selectedCountry.dial}</span>
              <i className="fas fa-chevron-down" style={{ fontSize: '0.6rem', opacity: 0.6 }}></i>
            </button>
            {prefixOpen && (
              <div className="ls-prefix-dropdown">
                <input
                  type="text"
                  className="ls-prefix-search"
                  placeholder="Buscar país..."
                  value={prefixSearch}
                  onChange={e => this.setState({ prefixSearch: e.target.value })}
                  onClick={e => e.stopPropagation()}
                  autoFocus
                />
                {PHONE_PREFIXES.filter(p => {
                  const s = prefixSearch.toLowerCase();
                  return !s || p.name.toLowerCase().includes(s) || p.dial.includes(s) || p.code.toLowerCase().includes(s);
                }).map(p => (
                  <div
                    key={p.code}
                    className={`ls-prefix-option${p.dial === phonePrefix ? ' selected' : ''}`}
                    onClick={() => this.setState({ phonePrefix: p.dial, prefixOpen: false, prefixSearch: '' })}
                  >
                    <ReactCountryFlag
                      countryCode={p.code}
                      svg
                      style={{ width: '1.3em', height: '1.3em', borderRadius: '3px' }}
                    />
                    <span className="ls-prefix-dial">{p.dial}</span>
                    <span className="ls-prefix-name">{p.name}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <input
            className="ls-phone-number"
            placeholder="600 000 000"
            type="tel"
            maxLength={12}
            value={this.state.phoneValue}
            onChange={(e) => {
              const inputPhone = e.target.value.replace(/\D/g, '');
              const { lockerPhones = [] } = this.state;

              const isDuplicate = lockerPhones.includes(inputPhone.trim());

              this.setState({
                phoneValue: inputPhone,
                phoneDuplicate: isDuplicate,
              });
            }}
          />
        </div>
        {this.state.phoneDuplicate && (
          <p className="text-danger">
            Este teléfono ya está registrado en otra taquilla.
          </p>
        )}
        <div className="countdownTPV">
          <p>Tiempo para confirmar</p>
          {minutes.toString().padStart(2, "0")}:
          {seconds.toString().padStart(2, "0")}
        </div>
      </div>
    );
  }

  renderDevolution() {
    const {
      fetchingSale,
      saleNotFound,
      saleData,
      counterInvoiceData,
      confirmationStep,
      devolutionMethod,
    } = this.state;
    const { pda } = this.props;

    if (confirmationStep === 0) {
      return (
        <div className="input-container text-center mt-5">
          <p>Introduce el código de factura del ticket original:</p>
          <input
            className="full mt-2 mb-2"
            placeholder="Número de factura"
            type="text"
            value={this.state.ticketInvoice}
            onChange={this.handleInvoiceInput}
          />
          <div className="ls-btn-row mt-3">
            <button
              className="ls-btn-reset"
              onClick={() => this.setState({ choiceMade: 0 })}
            >
              <i className="fas fa-arrow-left"></i>VOLVER
            </button>
            <button
              className="ls-btn-assign"
              onClick={this.fetchSaleTicket}
              disabled={fetchingSale || !this.state.ticketInvoice}
            >
              <i className="fas fa-search mr-1"></i>Consultar Ticket
            </button>
          </div>

          {fetchingSale && <p className="mt-2">Buscando ticket...</p>}
          {saleNotFound && (
            <p className="text-danger mt-2">Factura no encontrada.</p>
          )}
        </div>
      );
    }

    if (confirmationStep === 1 && saleData) {
      const itemName = getLockersName(saleData.Items[0].item);

      return (
        <div className="row">
          <div className="col col-12 col-lg-6 ml-auto mr-auto">
            <div className="lockerTicket mt-5">
              <h1 className="lockTitle">
                <span>FACTURA ORIGINAL</span>
              </h1>
              <hr className="bg-vw-light" />
              <h5 className="lockTitle">
                <span className="text-vw-dark">TAQUILLA</span>
              </h5>
              <h1 className="lockTitle">
                <span>{saleData.Locker}</span>
              </h1>

              <h5 className="lockTitle">
                <span className="text-vw-dark">TIPO</span>
              </h5>
              <h1 className="lockTitle">
                <span>{itemName}</span>
              </h1>

              <h5 className="lockTitle">
                <span className="text-vw-dark">PAGADO CON</span>
              </h5>
              <h1 className="lockTitle">
                <span>{saleData.PaymentMethod}</span>
              </h1>

              <hr className="bg-vw-light" />
              <br />

              <h5 className="lockTitle">
                <span>{saleData.Customer.Fullname}</span>
              </h5>
              <br />

              <h5 className="lockTitle">
                <span className="text-vw-dark">Terminal:</span>
              </h5>
              <h5 className="lockTitle">
                <span>{saleData.Code.slice(0, -6)}</span>
              </h5>

              <h5 className="lockTitle">
                <span className="text-vw-dark">Factura simplificada:</span>
              </h5>
              <h5 className="lockTitle">
                <span>{saleData.Code}</span>
              </h5>

              <h5 className="lockTitle">
                <span className="text-vw-dark">Fecha/Hora:</span>
              </h5>
              <h5 className="lockTitle">
                <span>{new Date(saleData.TimeStamp).toLocaleString()}</span>
              </h5>
              <br />

              <h5 className="lockTitle">
                <span className="text-vw-dark">PRODUCTOS</span>
              </h5>
              <h5 className="lockTitleJustify">
                <span>
                  {saleData.Items[0].qty}x {itemName}
                </span>
                <span>{saleData.Amount.toFixed(2)}€</span>
              </h5>
              <br />

              <h5 className="lockTitleJustify">
                <span>MONEDA:</span>
                <span>EUR</span>
              </h5>
              <h5 className="lockTitleJustify">
                <span>BASE:</span>
                <span>{this.getBase(saleData.Amount).toFixed(2)}€</span>
              </h5>
              <h5 className="lockTitleJustify">
                <span>IVA:</span>
                <span>{this.getIva(saleData.Amount).toFixed(2)}€</span>
              </h5>

              <h5 className="lockTitle">
                <span>-----------------</span>
              </h5>

              <h5 className="lockTitleJustify">
                <span>TOTAL:</span>
                <span>{saleData.Amount.toFixed(2)}€</span>
              </h5>
              <br />
              <hr className="bg-vw-light" />
            </div>
          </div>
          <div className="col col-12 col-lg-6 ml-auto mr-auto">
            <div className="mt-5 text-center">
              <p>¡ADVERTENCIA!</p>
              <p>
                Esta operativa NO DEVUELVE importe de ningún tipo, este se tiene
                que gestionar de forma autónoma por los medios disponibles del
                cliente. Indicando a continuación el método de devolución
                elegido para que quede registrado en el sistema.
              </p>
              <div className="form-group mt-5">
                <label>Método de Devolución:</label>
                <div
                  className="btn-group btn-group-toggle d-flex justify-content-center mt-2"
                  data-toggle="buttons"
                >
                  <button
                    type="button"
                    className={`btn btn-outline-primary ${devolutionMethod === "TPV" ? "active" : ""}`}
                    onClick={() => this.setState({ devolutionMethod: "TPV" })}
                  >
                    <i className="fas fa-credit-card mr-2"></i>Tarjeta
                  </button>
                  <button
                    type="button"
                    className={`btn btn-outline-success ${devolutionMethod === "CASH" ? "active" : ""}`}
                    onClick={() => this.setState({ devolutionMethod: "CASH" })}
                  >
                    <i className="fas fa-money-bill-wave mr-2"></i>Efectivo
                  </button>
                  <button
                    type="button"
                    className={`btn btn-outline-secondary ${devolutionMethod === "FREE" ? "active" : ""}`}
                    onClick={() => this.setState({ devolutionMethod: "FREE" })}
                  >
                    <i className="fas fa-gift mr-2"></i>Gratis
                  </button>
                </div>
              </div>
              <button
                disabled={!devolutionMethod}
                className="btn bg-success text-white mt-5 mr-3"
                onClick={this.generateCounterInvoice}
              >
                Confirmar Devolución
              </button>
              <button
                className="btn bg-danger text-white mt-5"
                onClick={this.resetProcess}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (confirmationStep === 2 && counterInvoiceData) {
      const itemName = getLockersName(counterInvoiceData.Items[0].item);

      return (
        <div className="row">
          <div className="col col-12 col-lg-6 ml-auto mr-auto">
            <div className="lockerTicket mt-5" id="counterInvoicePrintable">
              <hr className="bg-vw-light" />
              <h5 className="lockTitle">
                <span className="text-vw-dark">TAQUILLA (DEVOLUCIÓN)</span>
              </h5>
              <h1 className="lockTitle">
                <span>{counterInvoiceData.Locker}</span>
              </h1>

              <h5 className="lockTitle">
                <span className="text-vw-dark">TIPO</span>
              </h5>
              <h1 className="lockTitle">
                <span>{itemName}</span>
              </h1>

              <h5 className="lockTitle">
                <span className="text-vw-dark">PAGADO CON</span>
              </h5>
              <h1 className="lockTitle">
                <span>{counterInvoiceData.PaymentMethod}</span>
              </h1>

              <hr className="bg-vw-light" />
              <br />

              <h5 className="lockTitle">
                <span>{counterInvoiceData.Customer.Fullname}</span>
              </h5>
              <br />

              <h5 className="lockTitle">
                <span className="text-vw-dark">Terminal:</span>
              </h5>
              <h5 className="lockTitle">
                <span>{counterInvoiceData.Code.slice(0, -6)}</span>
              </h5>

              <h5 className="lockTitle">
                <span className="text-vw-dark">Factura Original:</span>
              </h5>
              <h5 className="lockTitle">
                <span>{counterInvoiceData.OriginalInvoice}</span>
              </h5>

              <h5 className="lockTitle">
                <span className="text-vw-dark">Factura Devolución:</span>
              </h5>
              <h5 className="lockTitle">
                <span>{counterInvoiceData.Code}</span>
              </h5>

              <h5 className="lockTitle">
                <span className="text-vw-dark">Fecha/Hora:</span>
              </h5>
              <h5 className="lockTitle">
                <span>
                  {new Date(counterInvoiceData.TimeStamp).toLocaleString()}
                </span>
              </h5>
              <br />

              <h5 className="lockTitle">
                <span className="text-vw-dark">PRODUCTOS DEVUELTOS</span>
              </h5>
              <h5 className="lockTitleJustify">
                <span>
                  {counterInvoiceData.Items[0].qty}x {itemName}
                </span>
                <span>{counterInvoiceData.Amount.toFixed(2)}€</span>
              </h5>
              <br />

              <h5 className="lockTitleJustify">
                <span>MONEDA:</span>
                <span>EUR</span>
              </h5>
              <h5 className="lockTitleJustify">
                <span>BASE:</span>
                <span>
                  {this.getBase(counterInvoiceData.Amount).toFixed(2)}€
                </span>
              </h5>
              <h5 className="lockTitleJustify">
                <span>IVA:</span>
                <span>
                  {this.getIva(counterInvoiceData.Amount).toFixed(2)}€
                </span>
              </h5>

              <h5 className="lockTitle">
                <span>-----------------</span>
              </h5>

              <h5 className="lockTitleJustify">
                <span>TOTAL DEVUELTO:</span>
                <span>{counterInvoiceData.Amount.toFixed(2)}€</span>
              </h5>
              <br />
              <hr className="bg-vw-light" />
            </div>
          </div>
          <div className="col col-12 col-lg-6 ml-auto mr-auto">
            <p>¿Deseas imprimir la factura para entregársela al cliente?</p>
            <p>
              *Recuerda quedarte con la factura original si entregas la
              contrafactura
            </p>
            <div className="mt-5 text-center">
              <button
                className="btn bg-info text-white mt-5 mr-3"
                onClick={(e) =>
                  this.printLockerTicket(e, "counterInvoicePrintable")
                }
              >
                Imprimir Devolución
              </button>
              <button
                className="btn bg-secondary text-white mt-5"
                onClick={this.resetProcess}
              >
                Finalizar
              </button>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }

  prebookLocker(lockerKey, price) {
    const prebooking = {};

    this.setState({
      lockerSelected: lockerKey,
      stepBarStep: 3,
      lockerPrice: price,
    });

    prebooking.Customer = this.props.customer._id;
    prebooking.LockerSelected = lockerKey;
    prebooking.Zone = this.state.zoneSelected;
    prebooking.Accessibility = false;

    this.props
      .postPrebooking(prebooking)
      .then((answer) => {
        this.setState({
          prebooking: true,
          lockerAssigned: answer.response.answerPrebooking.LockerAssigned,
          lockerPin: answer.response.answerPrebooking.LockerPin,
          lockerMatricula: answer.response.answerPrebooking.LockerMatricula,
          lockerPhones: answer.response.answerPrebooking.LockerPhones,
        });

        this.startCountdown();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  bookLocker() {
    if (this.state.bookingInProgress) return;

    this.setState({ bookingInProgress: true });

    const { pda } = this.props;

    let salePetition = {};

    const currentDate = new Date();

    // Get the individual components of the date and time
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");

    // Create the formatted timestamp
    const timestamp = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

    salePetition.TimeStamp = timestamp;
    salePetition.Amount = parseInt(this.state.lockerPrice);
    salePetition.Code = pda.Code;
    salePetition.PaymentMethod = "PDA";
    salePetition.WorkerSession = "000000";
    salePetition.Language = "ES";
    salePetition.RedsysCode = "";
    salePetition.Locker = this.state.lockerAssigned;
    salePetition.Phone = this.state.phonePrefix + this.state.phoneValue;

    this.props
      .postPDAsale(salePetition)
      .then((answer) => {
        let bookingPetition = {};

        bookingPetition.LockerAssigned = this.state.lockerAssigned;
        bookingPetition.LockerPin = this.state.lockerPin;
        bookingPetition.Phone = this.state.phonePrefix + this.state.phoneValue;
        bookingPetition.Origin = "RP";

        this.setState({
          invoice: answer.response.toSaveSale.Code,
          time: `${day}-${month}-${year} ${hours}:${minutes}`,
        });

        this.props
          .postBooking(bookingPetition)
          .then((answer) => {
            clearInterval(this.countdownInterval);

            this.setState({
              booked: true,
              stepBarStep: 4,
              bookingInProgress: false,
            });
          })
          .catch((error) => {
            console.error(error);
            this.setState({ bookingInProgress: false });
          });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ bookingInProgress: false });
      });
  }

  addGroupLocker(lockerKey, price) {
    this.setState((prevState) => {
      const groupLockers = [
        ...prevState.groupLockers,
        {
          lockerKey,
          price,
          lockerAssigned: null,
          lockerPin: null,
          lockerMatricula: null,
          invoice: null,
        },
      ];

      const groupTotalPrice = groupLockers.reduce((sum, l) => sum + l.price, 0);

      return { groupLockers, groupTotalPrice };
    });
  }

  renderGroupLockers() {
    const { pda, matrixs, error, loading } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!pda || !matrixs || loading) {
      return (
        <div>
          <LoadingProgress />
          <h5>Esperando Zona...</h5>
        </div>
      );
    }

    const orderedLockerKeys = [
      "LOCKERBNS",
      "LOCKERCNS",
      "LOCKERBWS",
      "LOCKERCWS",
      "LOCKERBNM",
      "LOCKERCNM",
      "LOCKERBWM",
      "LOCKERCWM",
      "LOCKERBNL",
      "LOCKERCNL",
      "LOCKERBWL",
      "LOCKERCWL",
      "LOCKERBNXL",
      "LOCKERCNXL",
      "LOCKERBWXL",
      "LOCKERCWXL",
      "LOCKERBN2XL",
      "LOCKERCN2XL",
      "LOCKERBW2XL",
      "LOCKERCW2XL",
      "LOCKERBN3XL",
      "LOCKERCN3XL",
      "LOCKERBW3XL",
      "LOCKERCW3XL",
    ];

    const availableLockerCounts = {};

    matrixs.forEach((matrix) => {
      matrix.Locker.forEach((lock) => {
        if (lock.Configured && lock.Status === "BL") {
          const key = `LOCKER${lock.Mode}${lock.Wide}${lock.Type}`;
          availableLockerCounts[key] = (availableLockerCounts[key] || 0) + 1;
        }
      });
    });

    // Build a calendar price lookup for today keyed by type, filtered by selected zone
    const groupCalendarPriceMap = {};
    if (Array.isArray(pda.CalendarPrices)) {
      pda.CalendarPrices.forEach(entry => {
        if (entry.zone === this.state.zoneSelected) {
          groupCalendarPriceMap[entry.type] = { price: entry.price, fromCalendar: entry.fromCalendar };
        }
      });
    }

    const lockersRow = orderedLockerKeys
      .filter((lockerKey) => availableLockerCounts[lockerKey])
      .map((lockerKey) => {
        const lockerName = getLockersName(lockerKey);
        const lockerType = lockerKey.slice(6);
        const lockerItem = (pda.Items || []).find(
          (item) => item.item === lockerKey,
        );

        // Use calendar price if available for this zone/type, otherwise fall back to contract price
        const groupCalendarEntry = groupCalendarPriceMap[lockerType];
        const hasCalendarPrice = groupCalendarEntry && groupCalendarEntry.fromCalendar;
        const displayPrice = groupCalendarEntry !== undefined
          ? groupCalendarEntry.price
          : (lockerItem ? lockerItem.price : 0);

        const selectedCount = this.state.groupLockers.filter(
          (l) => l.lockerKey === lockerType,
        ).length;
        const availableCount = availableLockerCounts[lockerKey] || 0;
        const isSelected = selectedCount > 0;

        return (
          <div
            key={lockerKey}
            className={
              isSelected ? "cubeselected ls-group-cube" : "cube ls-group-cube"
            }
            onClick={() => {
              if (selectedCount < availableCount) {
                this.addGroupLocker(
                  lockerType,
                  displayPrice,
                );
              }
            }}
          >
            {isSelected && (
              <div className="ls-group-badge">{selectedCount}</div>
            )}
            <h5>{lockerName}</h5>
            <img
              src={this.getLockerPcPicture(lockerType)}
              alt={lockerName}
              className="ls-group-locker-img"
            />
            <div className="cube-price mb-1">
              {displayPrice !== undefined ? displayPrice.toFixed(2) + "€" : "N/A"}
            </div>
            <div className="ls-group-available">
              {availableCount - selectedCount} disponibles
            </div>
            {hasCalendarPrice && <span className="ls-calendar-badge" title="Precio de calendario"><i className="fas fa-calendar-alt"></i> Precio dinámico</span>}
            <div className="ls-group-actions">
              <button
                className="ls-group-btn ls-group-btn-minus"
                disabled={selectedCount === 0}
                onClick={(e) => {
                  e.stopPropagation();
                  if (selectedCount > 0) {
                    this.setState((prevState) => {
                      const idx = prevState.groupLockers.findIndex(
                        (l) => l.lockerKey === lockerType,
                      );
                      const groupLockers = [...prevState.groupLockers];
                      groupLockers.splice(idx, 1);
                      const groupTotalPrice = groupLockers.reduce(
                        (sum, l) => sum + l.price,
                        0,
                      );
                      return { groupLockers, groupTotalPrice };
                    });
                  }
                }}
              >
                <i className="fas fa-minus"></i>
              </button>
              <span className="ls-group-count">{selectedCount}</span>
              <button
                className="ls-group-btn ls-group-btn-plus"
                disabled={selectedCount >= availableCount}
                onClick={(e) => {
                  e.stopPropagation();
                  if (selectedCount < availableCount) {
                    this.addGroupLocker(
                      lockerType,
                      displayPrice,
                    );
                  }
                }}
              >
                <i className="fas fa-plus"></i>
              </button>
            </div>
          </div>
        );
      });

    if (lockersRow.length === 0) {
      return (
        <div className="p-5">
          <h5>Lamentamos informarte que no quedan taquillas disponibles</h5>
        </div>
      );
    }

    return (
      <>
        <div className="row justify-content-center">{lockersRow}</div>
        {this.state.groupLockers.length > 0 && (
          <div className="ls-group-summary">
            <div className="ls-group-summary-info">
              <span className="ls-group-summary-count">
                {this.state.groupLockers.length} taquilla
                {this.state.groupLockers.length !== 1 ? "s" : ""} seleccionada
                {this.state.groupLockers.length !== 1 ? "s" : ""}
              </span>
              <span className="ls-group-summary-total">
                Total: {this.state.groupTotalPrice.toFixed(2)}€
              </span>
              <div className="ls-group-summary-breakdown">
                {Object.values(
                  this.state.groupLockers.reduce((acc, l) => {
                    const name = getLockersName(`LOCKER${l.lockerKey}`);
                    if (!acc[l.lockerKey]) {
                      acc[l.lockerKey] = {
                        name,
                        qty: 0,
                        unitPrice: l.price,
                        subtotal: 0,
                      };
                    }
                    acc[l.lockerKey].qty += 1;
                    acc[l.lockerKey].subtotal += l.price;
                    return acc;
                  }, {}),
                ).map((line, i) => (
                  <div key={i} className="ls-group-summary-line">
                    <span>
                      {line.qty}x {line.name}
                    </span>
                    <span>{line.subtotal.toFixed(2)}€</span>
                  </div>
                ))}
              </div>
            </div>
            <button
              className="ls-btn-assign"
              onClick={() =>
                this.setState({ groupConfirmed: true, stepBarStep: 3 })
              }
            >
              <i className="fas fa-check-circle"></i>CONFIRMAR SELECCIÓN
            </button>
          </div>
        )}
      </>
    );
  }

  
  renderGroupPhone() {
    const { groupPhonePrefix, groupPrefixOpen, groupPrefixSearch } = this.state;
    const selectedCountry = PHONE_PREFIXES.find(p => p.dial === groupPhonePrefix) || PHONE_PREFIXES[0];

    return (
      <div className="input-container text-center">
        <p>
          Introduce un teléfono de respaldo para las{" "}
          {this.state.groupLockers.length} taquillas del grupo
        </p>
        <div className="ls-phone-row">
          <div className="ls-prefix-picker" ref={this.groupPrefixRef}>
            <button
              type="button"
              className="ls-prefix-trigger"
              onClick={() => this.setState(s => ({ groupPrefixOpen: !s.groupPrefixOpen }))}
            >
              <ReactCountryFlag
                countryCode={selectedCountry.code}
                svg
                style={{ width: '1.4em', height: '1.4em', borderRadius: '3px' }}
              />
              <span>{selectedCountry.dial}</span>
              <i className="fas fa-chevron-down" style={{ fontSize: '0.6rem', opacity: 0.6 }}></i>
            </button>
            {groupPrefixOpen && (
              <div className="ls-prefix-dropdown">
                <input
                  type="text"
                  className="ls-prefix-search"
                  placeholder="Buscar país..."
                  value={groupPrefixSearch}
                  onChange={e => this.setState({ groupPrefixSearch: e.target.value })}
                  onClick={e => e.stopPropagation()}
                  autoFocus
                />
                {PHONE_PREFIXES.filter(p => {
                  const s = groupPrefixSearch.toLowerCase();
                  return !s || p.name.toLowerCase().includes(s) || p.dial.includes(s) || p.code.toLowerCase().includes(s);
                }).map(p => (
                  <div
                    key={p.code}
                    className={`ls-prefix-option${p.dial === groupPhonePrefix ? ' selected' : ''}`}
                    onClick={() => this.setState({ groupPhonePrefix: p.dial, groupPrefixOpen: false, groupPrefixSearch: '' })}
                  >
                    <ReactCountryFlag
                      countryCode={p.code}
                      svg
                      style={{ width: '1.3em', height: '1.3em', borderRadius: '3px' }}
                    />
                    <span className="ls-prefix-dial">{p.dial}</span>
                    <span className="ls-prefix-name">{p.name}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <input
            className="ls-phone-number"
            placeholder="600 000 000"
            type="tel"
            maxLength={12}
            value={this.state.groupPhoneValue}
            onChange={(e) => this.setState({ groupPhoneValue: e.target.value.replace(/\D/g, '') })}
          />
        </div>
      </div>
    );
  }

  async bookGroupLockers() {
    if (this.state.groupBookingInProgress) return;

    this.setState({ groupBookingInProgress: true });

    const { pda } = this.props;
    const results = [];
    const errors = [];

    for (let i = 0; i < this.state.groupLockers.length; i++) {
      const locker = this.state.groupLockers[i];

      this.setState({ groupBookingCurrent: i + 1 });

      try {
        const prebookRes = await this.props.postPrebooking({
          Customer: this.props.customer._id,
          LockerSelected: locker.lockerKey,
          Zone: this.state.zoneSelected,
          Accessibility: false,
        });

        const { LockerAssigned, LockerPin, LockerMatricula } =
          prebookRes.response.answerPrebooking;

        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const hours = String(currentDate.getHours()).padStart(2, "0");
        const mins = String(currentDate.getMinutes()).padStart(2, "0");
        const secs = String(currentDate.getSeconds()).padStart(2, "0");
        const timestamp = `${year}-${month}-${day}T${hours}:${mins}:${secs}`;

        const saleRes = await this.props.postPDAsale({
          TimeStamp: timestamp,
          Amount: parseInt(locker.price),
          Code: pda.Code,
          PaymentMethod: "PDA",
          WorkerSession: "000000",
          Language: "ES",
          RedsysCode: "",
          Locker: LockerAssigned,
          Phone: this.state.groupPhonePrefix + this.state.groupPhoneValue,
        });

        await this.props.postBooking({
          LockerAssigned,
          LockerPin,
          Phone: this.state.groupPhonePrefix + this.state.groupPhoneValue,
          Origin: "RP",
        });

        results.push({
          ...locker,
          lockerAssigned: LockerAssigned,
          lockerPin: LockerPin,
          lockerMatricula: LockerMatricula,
          invoice: saleRes.response.toSaveSale.Code,
          time: `${day}-${month}-${year} ${hours}:${mins}`,
          success: true,
        });
      } catch (error) {
        console.error(`Error booking locker ${i + 1}:`, error);
        errors.push({ ...locker, index: i, error });

        try {
          await this.props.postCancelPrebooking({
            LockerAssigned: locker.lockerAssigned,
          });
        } catch (cancelError) {
          console.error("Cancel prebooking failed:", cancelError);
        }
      }
    }

    this.setState({
      groupLockers: results,
      groupBookingComplete: true,
      groupBookingInProgress: false,
    });
  }

  printAllGroupTickets() {
    const { groupLockers } = this.state;
    groupLockers.forEach((locker, index) => {
      if (locker.success) {
        setTimeout(() => {
          this.printLockerTicket(null, `groupTicket-${index}`);
        }, index * 500);
      }
    });
  }

  resetProcess = () => {
    this.setState({
      choiceMade: 0,
      isTimeUp: false,
      zoneSelected: 0,
      lockerSelected: "",
      lockerAssigned: false,
      prebooking: false,
      stepBarStep: 1,
      booked: false,
      ticketInvoice: "",
      saleData: null,
      counterInvoiceData: null,
      fetchingSale: false,
      saleNotFound: false,
      confirmationStep: 0,
      devolutionMethod: null,
      groupLockers: [],
      groupTotalPrice: 0,
      groupBookingComplete: false,
      groupBookingInProgress: false,
      groupBookingCurrent: 0,
      groupPhoneValue: "",
      groupConfirmed: false,
      phonePrefix: '+34',
      prefixOpen: false,
      prefixSearch: '',
      groupPhonePrefix: '+34',
      groupPrefixOpen: false,
      groupPrefixSearch: '',
    });

    clearInterval(this.countdownInterval);
  };

  getBase(price) {
    const taxRate = 0.21;
    const base = price / (1 + taxRate);
    return base;
  }

  getIva(price) {
    const taxRate = 0.21;
    const base = this.getBase(price);
    const iva = price - base;
    return iva;
  }

  renderBlocked() {
    const { role } = this.props;
    const isAdmin = role === "ADMIN";

    return (
      <div className="ls-blocked-wrap">
        <div className="ls-blocked-card">
          <div className={`ls-blocked-icon ${isAdmin ? "admin" : "customer"}`}>
            <i className={isAdmin ? "fas fa-shield-alt" : "fas fa-lock"}></i>
          </div>
          <h2 className="ls-blocked-title">
            {isAdmin
              ? "Acceso Restringido"
              : "Acceso Exclusivo para Usuarios Operativos"}
          </h2>
          <p className="ls-blocked-subtitle">
            {isAdmin
              ? "Esta sección está destinada exclusivamente a usuarios Operativos. Los administradores no tienen acceso a la venta directa de taquillas. Utiliza el panel de administración para gestionar ventas."
              : "La venta de taquillas desde este módulo solo está disponible para cuentas de tipo Operativo. Tu cuenta actual no tiene acceso directo."}
          </p>

          {!isAdmin && (
            <>
              <div className="ls-steps-box">
                <h6>¿Cómo acceder al módulo de venta?</h6>
                <div className="ls-step-item">
                  <span className="ls-step-num">1</span>
                  <span className="ls-step-text">
                    Ve a la sección <strong>Usuarios &rarr; Operativos</strong>{" "}
                    desde el menú principal y crea un usuario Operativo asociado
                    a tu cuenta.
                  </span>
                </div>
                <div className="ls-step-item">
                  <span className="ls-step-num">2</span>
                  <span className="ls-step-text">
                    Cierra sesión con tu cuenta actual.
                  </span>
                </div>
                <div className="ls-step-item">
                  <span className="ls-step-num">3</span>
                  <span className="ls-step-text">
                    Inicia sesión con las credenciales del usuario Operativo que
                    acabas de crear.
                  </span>
                </div>
                <div className="ls-step-item">
                  <span className="ls-step-num">4</span>
                  <span className="ls-step-text">
                    Accede de nuevo a esta sección para empezar a realizar
                    ventas.
                  </span>
                </div>
              </div>
              <button
                className="ls-btn-cta"
                onClick={() => this.props.push("/my-pda-users")}
              >
                <i className="fas fa-users-cog"></i>
                Ir a Gestión de Usuarios Operativos
              </button>
            </>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { fullname, pda, role, type } = this.props;
    const { isTimeUp } = this.state;

    if (type !== "PDA") {
      return this.renderBlocked();
    }

    return (
      <div className="ls-sale-view">
        <div className="ls-sale-wrap">
          <div className="ls-sale-content">
            {this.state.choiceMade === 0 && (
              <div className="ls-section">
                <h2 className="ls-section-title">
                  ¿QUIERES VENDER O DEVOLVER UNA TAQUILLA?
                </h2>
                <div className="ls-choice-grid">{this.renderChoice()}</div>
              </div>
            )}
            {this.state.choiceMade === 1 && this.state.zoneSelected === 0 && (
              <div className="ls-section">
                <h2 className="ls-section-title">INDICA LA ZONA</h2>
                <div className="row justify-content-center">
                  {this.renderZones()}
                </div>
              </div>
            )}
            {this.state.choiceMade === 1 &&
              this.state.zoneSelected !== 0 &&
              !this.state.lockerSelected && (
                <div className="ls-section">
                  <h2 className="ls-section-title">SELECCIONA UNA TAQUILLA</h2>
                  <div className="row justify-content-center">
                    {this.renderLockers()}
                  </div>
                </div>
              )}
            {this.state.choiceMade === 1 &&
              this.state.zoneSelected !== 0 &&
              this.state.lockerSelected &&
              !this.state.booked && (
                <div className="ls-section">
                  <h2 className="ls-section-title">TELÉFONO DE RESPALDO</h2>
                  {this.state.prebooking ? (
                    <div className="row justify-content-center pt-2 pr-5 pl-5">
                      {this.renderPhone()}
                    </div>
                  ) : (
                    <div>
                      <LoadingProgress />
                      <h5 className="ct">Esperando Taquilla...</h5>
                    </div>
                  )}
                </div>
              )}
            {this.state.choiceMade === 2 && (
              <div className="ls-section">
                <h2 className="ls-section-title">DEVOLUCIÓN DE TAQUILLA</h2>
                <div className="row justify-content-center">
                  {this.renderDevolution()}
                </div>
              </div>
            )}
            {this.state.choiceMade === 3 && this.state.zoneSelected === 0 && (
              <div className="ls-section">
                <h2 className="ls-section-title">INDICA LA ZONA (GRUPO)</h2>
                <div className="row justify-content-center">
                  {this.renderZones()}
                </div>
              </div>
            )}
            {this.state.choiceMade === 3 &&
              this.state.zoneSelected !== 0 &&
              !this.state.groupConfirmed && (
                <div className="ls-section">
                  <h2 className="ls-section-title">
                    SELECCIONA TAQUILLAS PARA EL GRUPO
                  </h2>
                  {this.renderGroupLockers()}
                </div>
              )}
            {this.state.choiceMade === 3 &&
              this.state.groupConfirmed &&
              !this.state.groupBookingComplete && (
                <div className="ls-section">
                  <h2 className="ls-section-title">
                    TELÉFONO DE RESPALDO (GRUPO)
                  </h2>
                  <div className="row justify-content-center pt-2 pr-5 pl-5">
                    {this.renderGroupPhone()}
                  </div>
                  {this.state.groupBookingInProgress && (
                    <div className="text-center mt-3">
                      <LoadingProgress />
                      <h5>
                        Procesando taquilla {this.state.groupBookingCurrent} de{" "}
                        {this.state.groupLockers.length}...
                      </h5>
                    </div>
                  )}
                </div>
              )}
            {this.state.choiceMade === 3 && this.state.groupBookingComplete && (
              <div className="ls-section">
                <h2 className="ls-section-title">RESERVA GRUPAL COMPLETADA</h2>
                <div className="ls-group-results">
                  <div className="ls-group-results-summary">
                    <span>
                      {this.state.groupLockers.filter((l) => l.success).length}{" "}
                      de {this.state.groupLockers.length} taquillas asignadas
                    </span>
                    <span className="ls-group-results-total">
                      Total: {this.state.groupTotalPrice.toFixed(2)}€
                    </span>
                  </div>
                  {this.state.groupLockers
                    .filter((l) => l.success)
                    .map((locker, index) => (
                      <div key={index} className="ls-ticket-wrap mb-3">
                        <div className="ls-ticket" id={`groupTicket-${index}`}>
                          <div className="ls-ticket-header">
                            <span className="ls-ticket-label">TAQUILLA</span>
                            <span className="ls-ticket-big">
                              {locker.lockerMatricula}
                            </span>
                          </div>
                          <div className="ls-ticket-hero">
                            <span className="ls-ticket-label">PIN</span>
                            <span className="ls-ticket-pin">
                              {locker.lockerPin}
                            </span>
                          </div>
                          <div className="ls-ticket-type">
                            {getLockersName(`LOCKER${locker.lockerKey}`)}
                          </div>
                          <div className="ls-ticket-divider"></div>
                          <div className="ls-ticket-company">
                            {this.state.customer}
                          </div>
                          <div className="ls-ticket-sub">{this.state.cif}</div>
                          <div className="ls-ticket-sub">
                            {this.state.address}
                          </div>
                          <div className="ls-ticket-divider"></div>
                          <div className="ls-ticket-row">
                            <span>Terminal</span>
                            <span>{pda.Code}</span>
                          </div>
                          <div className="ls-ticket-row">
                            <span>Factura</span>
                            <span>{locker.invoice}</span>
                          </div>
                          <div className="ls-ticket-row">
                            <span>Fecha/Hora</span>
                            <span>{locker.time}</span>
                          </div>
                          <div className="ls-ticket-divider"></div>
                          <div className="ls-ticket-row ls-ticket-row-bold">
                            <span>
                              1x {getLockersName(`LOCKER${locker.lockerKey}`)}
                            </span>
                            <span>{locker.price.toFixed(2)}€</span>
                          </div>
                          <div className="ls-ticket-divider-dashed"></div>
                          <div className="ls-ticket-row ls-ticket-row-sm">
                            <span>Base</span>
                            <span>
                              {this.getBase(locker.price).toFixed(2)}€
                            </span>
                          </div>
                          <div className="ls-ticket-row ls-ticket-row-sm">
                            <span>IVA</span>
                            <span>{this.getIva(locker.price).toFixed(2)}€</span>
                          </div>
                          <div className="ls-ticket-row ls-ticket-total">
                            <span>TOTAL</span>
                            <span>{locker.price.toFixed(2)}€</span>
                          </div>
                        </div>
                        <div className="ls-ticket-actions">
                          <button
                            className="ls-btn-print"
                            onClick={(e) =>
                              this.printLockerTicket(e, `groupTicket-${index}`)
                            }
                          >
                            <i className="fas fa-print"></i>TICKET
                          </button>
                          <button
                            className="ls-btn-pin"
                            onClick={(e) =>
                              this.printLockerTicket(
                                e,
                                `groupPinTicket-${index}`,
                              )
                            }
                          >
                            <i className="fas fa-print"></i>PIN
                          </button>
                        </div>
                        <div
                          style={{ display: "none" }}
                          id={`groupPinTicket-${index}`}
                        >
                          <div className="ls-ticket">
                            <div className="ls-ticket-header">
                              <span className="ls-ticket-label">TAQUILLA</span>
                              <span className="ls-ticket-big">
                                {locker.lockerMatricula}
                              </span>
                            </div>
                            <div className="ls-ticket-hero">
                              <span className="ls-ticket-label">PIN</span>
                              <span className="ls-ticket-pin">
                                {locker.lockerPin}
                              </span>
                            </div>
                            <div className="ls-ticket-type">
                              {getLockersName(`LOCKER${locker.lockerKey}`)}
                            </div>
                            <div className="ls-ticket-divider"></div>
                            <div className="ls-ticket-company">
                              {this.state.customer}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
          <div className="ls-action-bar">
            {!this.state.booked ? (
              <div className="ls-btn-row">
                {this.state.choiceMade === 1 && (
                  <>
                    <button
                      className="ls-btn-reset"
                      onClick={() => this.resetProcess()}
                    >
                      <i className="fas fa-arrow-left"></i>VOLVER
                    </button>
                    <button
                      className="ls-btn-assign"
                      disabled={
                        !this.state.lockerAssigned ||
                        this.state.phoneValue.length < 6 ||
                        this.state.phoneDuplicate
                      }
                      onClick={() => this.bookLocker()}
                    >
                      <i className="fas fa-check-circle"></i>ASIGNAR
                    </button>
                  </>
                )}
                {this.state.choiceMade === 3 && (
                  <>
                    <button
                      className="ls-btn-reset"
                      onClick={() => this.resetProcess()}
                    >
                      <i className="fas fa-arrow-left"></i>VOLVER
                    </button>
                    {this.state.groupConfirmed &&
                      !this.state.groupBookingComplete && (
                        <button
                          className="ls-btn-assign"
                          disabled={
                            this.state.groupPhoneValue.length < 6 ||
                            this.state.groupBookingInProgress
                          }
                          onClick={() => this.bookGroupLockers()}
                        >
                          <i className="fas fa-check-circle"></i>ASIGNAR GRUPO (
                          {this.state.groupLockers.length})
                        </button>
                      )}
                    {this.state.groupBookingComplete && (
                      <button
                        className="ls-btn-print"
                        onClick={() => this.printAllGroupTickets()}
                      >
                        <i className="fas fa-print"></i>IMPRIMIR TODOS
                      </button>
                    )}
                  </>
                )}
              </div>
            ) : (
              <div className="ls-btn-row">
                <button
                  className="ls-btn-reset"
                  onClick={() => this.resetProcess()}
                >
                  <i className="fas fa-arrow-left"></i>VOLVER
                </button>
                <button
                  className="ls-btn-print"
                  disabled={
                    !this.state.lockerAssigned ||
                    this.state.phoneValue.length < 6
                  }
                  onClick={(e) => this.printLockerTicket(e, "printableTicket")}
                >
                  <i className="fas fa-print"></i>IMPRIMIR TICKET
                </button>
                <button
                  className="ls-btn-pin"
                  disabled={
                    !this.state.lockerAssigned ||
                    this.state.phoneValue.length < 6
                  }
                  onClick={(e) =>
                    this.printLockerTicket(e, "printablePinTicket")
                  }
                >
                  <i className="fas fa-print"></i>IMPRIMIR PIN
                </button>
              </div>
            )}
            {this.state.booked && (
              <div className="ls-ticket-wrap">
                <div className="ls-ticket" id="printableTicket">
                  <div className="ls-ticket-header">
                    <span className="ls-ticket-label">TAQUILLA</span>
                    <span className="ls-ticket-big">
                      {this.state.lockerMatricula}
                    </span>
                  </div>
                  <div className="ls-ticket-hero">
                    <span className="ls-ticket-label">PIN</span>
                    <span className="ls-ticket-pin">
                      {this.state.lockerPin}
                    </span>
                  </div>
                  <div className="ls-ticket-type">
                    {getLockersName(`LOCKER${this.state.lockerSelected}`)}
                  </div>
                  <div className="ls-ticket-divider"></div>
                  <div className="ls-ticket-company">{this.state.customer}</div>
                  <div className="ls-ticket-sub">{this.state.cif}</div>
                  <div className="ls-ticket-sub">{this.state.address}</div>
                  <div className="ls-ticket-divider"></div>
                  <div className="ls-ticket-row">
                    <span>Terminal</span>
                    <span>{pda.Code}</span>
                  </div>
                  <div className="ls-ticket-row">
                    <span>Factura</span>
                    <span>{this.state.invoice}</span>
                  </div>
                  <div className="ls-ticket-row">
                    <span>Fecha/Hora</span>
                    <span>{this.state.time}</span>
                  </div>
                  <div className="ls-ticket-divider"></div>
                  <div className="ls-ticket-row ls-ticket-row-bold">
                    <span>
                      1x {getLockersName(`LOCKER${this.state.lockerSelected}`)}
                    </span>
                    <span>{this.state.lockerPrice.toFixed(2)}€</span>
                  </div>
                  <div className="ls-ticket-divider-dashed"></div>
                  <div className="ls-ticket-row ls-ticket-row-sm">
                    <span>Base</span>
                    <span>
                      {this.getBase(this.state.lockerPrice).toFixed(2)}€
                    </span>
                  </div>
                  <div className="ls-ticket-row ls-ticket-row-sm">
                    <span>IVA</span>
                    <span>
                      {this.getIva(this.state.lockerPrice).toFixed(2)}€
                    </span>
                  </div>
                  <div className="ls-ticket-row ls-ticket-total">
                    <span>TOTAL</span>
                    <span>{this.state.lockerPrice.toFixed(2)}€</span>
                  </div>
                </div>
              </div>
            )}
            {this.state.booked && (
              <div style={{ display: "none" }} id="printablePinTicket">
                <div className="ls-ticket">
                  <div className="ls-ticket-header">
                    <span className="ls-ticket-label">TAQUILLA</span>
                    <span className="ls-ticket-big">
                      {this.state.lockerMatricula}
                    </span>
                  </div>
                  <div className="ls-ticket-hero">
                    <span className="ls-ticket-label">PIN</span>
                    <span className="ls-ticket-pin">
                      {this.state.lockerPin}
                    </span>
                  </div>
                  <div className="ls-ticket-type">
                    {getLockersName(`LOCKER${this.state.lockerSelected}`)}
                  </div>
                  <div className="ls-ticket-divider"></div>
                  <div className="ls-ticket-company">{this.state.customer}</div>
                </div>
              </div>
            )}
          </div>
          {(this.state.choiceMade === 1 || this.state.choiceMade === 3) && (
            <div className="ls-stepbar-fixed">
              <StepBar step={this.state.stepBarStep} />
            </div>
          )}
          <div>
            <Modal isOpen={isTimeUp}>
              <ModalHeader>Tiempo de reserva agotado</ModalHeader>
              <ModalBody>
                Lo sentimos, pero no podemos reservar tu taquilla por más
                tiempo, otros usuarios deben poder acceder a ella. Vuelve a
                iniciar el proceso y finaliza la compra en el tiempo estipulado.
              </ModalBody>
              <ModalFooter>
                <Button
                  color="warning"
                  className="button-center"
                  onClick={this.handleRedirect}
                >
                  Volver al inicio
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  customer: state.customers.customer,
  matrixs: state.matrixs.matrixs,
  pda: state.pdas.pda,
  error: state.matrixs.error,
  loading: state.matrixs.loading,
  role: state.auth.role,
  type: state.auth.type,
  category: state.auth.category,
  fullname: state.auth.fullname,
  id: state.auth.id,
  form: state.form,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
  fetchMatrixs: bindActionCreators(fetchMatrixs, dispatch),
  fetchPDACustomer: bindActionCreators(fetchPDACustomer, dispatch),
  postBooking: bindActionCreators(postBooking, dispatch),
  postPrebooking: bindActionCreators(postPrebooking, dispatch),
  postCancelPrebooking: bindActionCreators(postCancelPrebooking, dispatch),
  postPDAsale: bindActionCreators(postPDAsale, dispatch),
  fetchSaleTicket: bindActionCreators(fetchSaleTicket, dispatch),
  postCounterInvoicePDASale: bindActionCreators(
    postCounterInvoicePDASale,
    dispatch,
  ),
  push: bindActionCreators(push, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LockerSaleView);
